import React from "react";

const HomeAbout = () => {
  return (
    <section className="bg-sec py-20 px-6 lg:px-0">
      <div className="max-w-screen-2xl   mx-auto grid lg:grid-cols-2 gap-16 items-center">
        {/* LEFT – Image Area */}
        <div className="relative">
          <div className=" rounded-3xl p-10 relative overflow-hidden">
            {/* Main Model Image */}
            <img
              src="https://www.ohsogo.com/cdn/shop/products/274859840_3287864258205034_6426977427325829482_n.png?v=1696420753&width=1500"
              alt="Hair Serum Model"
              className="relative z-10  w-full object-cover"
            />

            {/* Floating bubbles */}
            <span className="absolute top-10 left-10 w-6 h-6 bg-white/60  blur-sm" />
            <span className="absolute top-24 right-16 w-10 h-10 bg-white/50 rounded-full blur-md" />
            <span className="absolute bottom-16 left-20 w-8 h-8 bg-white/40 rounded-full blur" />

            {/* Floating aloe */}
            <img
              src="https://pngimg.com/uploads/aloe_vera/aloe_vera_PNG66.png"
              className="absolute -bottom-6 -right-6 w-32 opacity-90"
              alt=""
            />
          </div>
        </div>

        {/* RIGHT – Content */}
        <div className="text-center lg:text-left">
          <span className="text-xs tracking-[0.3em] uppercase text-gray-500 font-semibold">
            Pure and Simple
          </span>

          <h2 className="mt-4 text-3xl lg:text-3xl font-semibold leading-tight text-gray-900">
            Deeply Nourishing Hair Serum <br />
            For Glowing & Healthy Hair
          </h2>

          <p className="mt-6  leading-relaxed max-w-xl mx-auto lg:mx-0">
            Our advanced clean-beauty serum deeply nourishes each strand,
            restoring strength, shine and smoothness using nature-powered
            ingredients.
          </p>

          {/* Feature Icons */}
          <div className="mt-10 grid grid-cols-2 gap-6 max-w-md mx-auto lg:mx-0">
            <div className="flex items-center gap-3 justify-center lg:justify-start">
              <img
                src="https://luvit.com.bd/wp-content/uploads/2026/01/1e4krgzs2ywjlsttc9jr.svg"
                alt="Strong & Smooth"
                className="w-10 h-10 object-contain"
              />
              <span className="text-sm text-gray-900">Strong & Smooth</span>
            </div>

            <div className="flex items-center gap-3 justify-center lg:justify-start">
              <img
                src="https://luvit.com.bd/wp-content/uploads/2026/01/bq65rkwd0c5lsttd5cv.svg"
                alt="Paraben-Free"
                className="w-10 h-10 object-contain"
              />
              <span className="text-sm text-gray-900">100% Healthy</span>
            </div>

            <div className="flex items-center gap-3 justify-center lg:justify-start">
              <img
                src="https://luvit.com.bd/wp-content/uploads/2026/01/6mlrlne4loelsttezhk.svg"
                alt="Sulphate-Free"
                className="w-10 h-10 object-contain"
              />
              <span className="text-sm text-gray-900">Good Quality</span>
            </div>

            <div className="flex items-center gap-3 justify-center lg:justify-start">
              <img
                src="https://luvit.com.bd/wp-content/uploads/2026/01/d6tfuz01gvlsttea3k.svg"
                alt="100% Vegan"
                className="w-10 h-10 object-contain"
              />
              <span className="text-sm text-gray-900">100% Vegan</span>
            </div>
          </div>

          {/* Button */}
          <a
            href="/shop"
            className="inline-block mt-12 px-10 py-4 text-sm tracking-widest rounded-md  transition text-white bg-accent hover:bg-secondary"
          >
            SHOP NOW
          </a>
        </div>
      </div>
    </section>
  );
};

export default HomeAbout;

// import React from "react";
// import { Helmet } from "react-helmet-async";
// import about from "../Images/About.jpg";

// const HomeAbout = () => {
//   return (
//     <section
//       className="relative py-20 px-6 lg:px-20 overflow-hidden"
//       aria-labelledby="home-about-heading"
//     >
//       <Helmet>
//         <title>Clariss Bangladesh | Luxury Vegan & Organic Skincare</title>
//         <meta
//           name="description"
//           content="Clariss Bangladesh combines organic ingredients, cruelty-free formulas, and eco-conscious beauty. Discover premium skincare, body care & fragrances for a natural glow."
//         />
//         <meta
//           name="keywords"
//           content="Clariss Bangladesh, organic skincare, cruelty-free beauty, vegan products Bangladesh, natural body care, luxury fragrances, toxin-free skincare"
//         />
//         <link rel="canonical" href="https://clariss.com.bd" />
//       </Helmet>

//       <div className="absolute -top-20 -left-20 w-[300px] h-[300px] bg-accent/10 rounded-full blur-3xl"></div>
//       <div className="absolute bottom-0 right-0 w-[250px] h-[250px] bg-secondary/10 rounded-full blur-3xl"></div>

//       <div className="text-center max-w-4xl mx-auto">
//         <span className="text-accent uppercase tracking-widest font-semibold">
//           Inspired by Nature • Backed by Science
//         </span>
//         <h2
//           id="home-about-heading"
//           className="mt-3 text-4xl lg:text-5xl font-extrabold text-secondary leading-tight"
//         >
//           Clariss – Where Nature Meets Luxury Beauty
//         </h2>
//         <p className="mt-4 text-lg lg:text-xl text-gray-700 font-medium">
//           Experience cruelty-free, vegan & organic skincare designed for your
//           unique radiance.
//         </p>
//       </div>

//       <div className="mt-16 grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
//         <div className="text-gray-700 text-base lg:text-lg leading-relaxed animate-fade-in">
//           <p className="mb-5">
//             <strong>Clariss</strong> brings you{" "}
//             <strong>premium skincare, body care & fragrances</strong> powered by{" "}
//             <strong>certified organic ingredients</strong> and advanced clean
//             beauty science. Our{" "}
//             <strong>vegan, cruelty-free & toxin-free</strong> formulas deliver
//             safe, sustainable & effective beauty solutions curated for all skin
//             types.
//           </p>
//           <p className="mb-5">
//             From <strong>hydrating face washes</strong> and{" "}
//             <strong>luxurious body essentials</strong> to{" "}
//             <strong>signature fragrances</strong>, every Clariss product
//             reflects our philosophy of <em>nature-inspired beauty</em> that
//             enhances your natural glow.
//           </p>
//           <p className="mb-5">
//             We believe in <strong>eco-conscious beauty</strong>—no harmful
//             chemicals, no animal testing—just{" "}
//             <strong>authentic skincare that cares for you & the planet.</strong>
//           </p>
//           <div className="mt-8">
//             <a
//               href="/shop"
//               className="inline-block px-10 py-4 bg-accent text-white text-lg font-bold rounded-xl shadow-md hover:shadow-xl hover:bg-secondary transition duration-300"
//             >
//               🌿 Explore Clariss Collection
//             </a>
//           </div>
//         </div>

//         <div className="relative animate-fade-in-up">
//           <img
//             src={about}
//             alt="Organic skincare presentation"
//             className="rounded-2xl shadow-2xl hover:scale-[1.02] transition-transform duration-500"
//           />
//           <div className="absolute -top-10 -right-6 bg-white shadow-lg p-4 rounded-xl">
//             <p className="text-accent font-bold text-sm">100% Vegan</p>
//             <p className="text-xs text-gray-500">Cruelty‑Free Certified</p>
//           </div>
//         </div>
//       </div>

//       <div className="mt-20 grid sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
//         {[
//           {
//             icon: "🌱",
//             title: "Organic & Safe",
//             desc: "Certified organic & plant-based ingredients for a healthy glow.",
//           },
//           {
//             icon: "🐰",
//             title: "Cruelty-Free",
//             desc: "100% vegan & cruelty-free beauty products with zero animal testing.",
//           },
//           {
//             icon: "🌸",
//             title: "Non-Toxic",
//             desc: "Free from parabens, sulfates & harsh chemicals for safe daily care.",
//           },
//           {
//             icon: "🇧🇩",
//             title: "Made for You",
//             desc: "Formulated for Bangladesh’s climate & skincare needs, trusted globally.",
//           },
//         ].map((item, i) => (
//           <div
//             key={i}
//             className="bg-white text-center shadow-md p-8 rounded-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300"
//           >
//             <div className="text-4xl">{item.icon}</div>
//             <h3 className="mt-4 text-xl font-bold text-secondary">
//               {item.title}
//             </h3>
//             <p className="mt-2 text-sm text-gray-600">{item.desc}</p>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default HomeAbout;
